module.exports = function(service) {
	'use strict'
	service.factory('keyPressOnlyNumberAndDot', keyPressOnlyNumberAndDot);
	keyPressOnlyNumberAndDot.$inject = [];
	function keyPressOnlyNumberAndDot() {
	   return function(evt) {
			evt = (evt) ? evt : event;
		    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
		    ((evt.which) ? evt.which : 0));
		    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
		        evt.preventDefault();
		    }
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/keyPressOnlyNumberAndDotService.js
// module id = 612
// module chunks = 0